import styles from './VehicleOriginalPrice.module.scss';

type VehicleOriginalPriceProps = {
	price: string;
};

export const VehicleOriginalPrice: React.FC<VehicleOriginalPriceProps> = ({ price }) => {
	return <div className={styles.vehicleOriginalPrice}>{price}</div>;
};
